import { fetcher } from "helpers/fetcher";

import { TUpdateStaffInsuranceReq, TUpdateStaffInsuranceRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateEmployeeInsurance = async (
  payload: TUpdateStaffInsuranceReq
) => {
  return await fetcher<
    TUpdateStaffInsuranceRes,
    TUpdateStaffInsuranceReq["data"]
  >(ENDPOINT.USER.UPDATE_EMPLOYEE_INSURANCE, {
    data: payload.data,
    headers: {
      [API_HEADER.USER_ID]: payload.idUser,
      [API_HEADER.VERSION]: ENDPOINT.USER.UPDATE_EMPLOYEE_INSURANCE.version,
    },
  });
};

export const mutationUpdateEmployeeInsurance = async (
  payload: TUpdateStaffInsuranceReq
) => {
  return (await updateEmployeeInsurance(payload)).data.message;
};

mutationUpdateEmployeeInsurance._key = (payload: TUpdateStaffInsuranceReq) => [
  ENDPOINT.USER.UPDATE_EMPLOYEE_INSURANCE.url,
  payload,
];
